export interface StepperStep {
  label: string;
  /** Marks this step as a "skip" (amber tag shown when skipped). */
  skipLabel?: string;
}

export interface StepperProps {
  steps: StepperStep[];
  currentIndex: number;
  variant?: 'apply' | 'booking' | 'editor';
}

/** Primitive 15: Shared 4/5/6-step stepper (RCP apply, RAE booking, PDF editor). */
export function Stepper({ steps, currentIndex, variant: _variant = 'apply' }: StepperProps): JSX.Element {
  return (
    <ol className="stepper" role="list" aria-label="progress steps">
      {steps.map((s, i) => {
        const isDone = i < currentIndex;
        const isActive = i === currentIndex;
        return (
          <li
            key={s.label}
            className={`stepper__step ${isDone ? 'is-done' : ''} ${isActive ? 'is-active' : ''}`.trim()}
            aria-current={isActive ? 'step' : undefined}
          >
            <span className="stepper__num">{isDone ? '✓' : i + 1}</span>
            <span>{s.label}</span>
            {s.skipLabel && (
              <span className="pill pill-warn" style={{ marginLeft: 'var(--sp-3)' }}>
                {s.skipLabel}
              </span>
            )}
          </li>
        );
      })}
    </ol>
  );
}
